import config from "../config.js";
import http from "./httpService.js";
import { getCurrentUserId } from "./loginService.js";

const apiEndpoint = `${config.apiUrl}/Users`;

export function getAllUsers() {
  var users = http.get(`${apiEndpoint}/All`);
  return users;
}

function userUrl(id) {
  return `${apiEndpoint}/${id}`;
}

export function getUsers() {
  return http.get(apiEndpoint);
}

export function getUser(userId) {
  return http.get(userUrl(userId));
}

export function getUsersByPage(pageNumber) {
  return http.get(apiEndpoint + "/page/" + pageNumber);
}

export function getSearchTypes() {
  return http.get(apiEndpoint + "/searchTypes");
}
export function searchUsers(searchText, searchType, page) {
  return http.get(
    apiEndpoint +
      `?searchText=${searchText}&searchType=${searchType}&Page=${page}`
  );
}

export function getUsersByRoleName(roleName, includeDeleted = false) {
  return http.get(
    apiEndpoint + `/role?roleNames=${roleName}&includeDeleted=${includeDeleted}`
  );
}

export function saveUser(user) {
  if (user) {
    user = { ...user, UserId: getCurrentUserId() };
  }
  if (user.Id) {
    return http.put(userUrl(user.Id), user);
  }
  return http.post(apiEndpoint, user);
}

export function quickSearchUsers(searchText) {
  return http.get(apiEndpoint + "/quick/" + searchText);
}
export function deleteUser(userId) {
  return http.delete(userUrl(userId));
}

export function isUserNameAvailable(userName) {
  return http.get(apiEndpoint + "/CheckUserName/" + userName);
}

export function getPermissions() {
  return http.get(apiEndpoint + "/permissions");
}
export function getRoles() {
  return http.get(apiEndpoint + "/roles");
}

export function getUserSettingDto(id) {
  return http.get(`${apiEndpoint}/Setting/${id}`);
}

export function postProfileImage(images, uploadConfig) {
  return http.post(`${apiEndpoint}/ProfileImage`, images, {
    ...uploadConfig,
  });
}

export function getProfileImage(userId) {
  return http.get(`${apiEndpoint}/ProfileImage?UserId=${userId}`);
}

export function changePassword(password) {
  return http.post(`${apiEndpoint}/ChangePassword`, password);
}
